import { create } from 'zustand';
import { persist } from 'zustand/middleware';


const useMenusStore = create(persist((set) => (
    {
        menus: [],
        activeMenu: {},
        setActiveMenu: (menu) => set({ activeMenu: menu }),
        setMenus: (menus) => set({ menus }),
        addMenu: (menu) => set((state) => ({ menus: [...state.menus, menu] })),
        updateMenu: (menu) => set((state) => ({
        menus: state.menus.map((m) => (m._id === menu._id ? menu : m)),
        })),
        deleteMenu: (menuId) => set((state) => ({
        menus: state.menus.filter((m) => m._id !== menuId),
        })),
    }
    ), {
    name: 'menus-store',
    }));

export default useMenusStore;
